import CancelOrderForm from 'components/CancelOrderForm';
import Paragraph from 'components/text/Paragraph';
import PropTypes from 'prop-types';
import React from 'react';
import { TextLinkWysisyg } from 'components/text/TextLink';
import Wysiwyg from 'libs/wordpress/components/Wysiwyg';
import styled from 'libs/styled';
import { wysiwygProp } from 'utils/proptypes/modules/textProps';

const Columns = styled('div')`
    display: grid;
    // 12 column grid with 5 columns for the intro and 7 columns for the form
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 24px;
    grid-row-gap: 24px;
`;

const Div = styled('div')``;

/**
 * Cancel order content block ("Ångra köp").
 * Two-column layout: an intro paragraph on the left, the cancel order form on the right.
 *
 * @param {object} confirmationPage - Transformed link to the page shown after a successful submit.
 * @param {array} text - Wysiwyg intro paragraph displayed in the left column.
 */

const CancelOrder = ({ confirmationPage, text }) => (
    <Columns>
        <Div key="intro" gridColumn={['1 / 13', null, null, '1 / 6']}>
            {text && (
                <Wysiwyg
                    data={text}
                    textComponent={props => <Paragraph size="xl" mb="32px" {...props} />}
                    tagComponents={{ url: TextLinkWysisyg }}
                />
            )}
        </Div>
        <Div key="form" gridColumn={['1 / 13', null, null, '7 / 13']}>
            <CancelOrderForm confirmationPage={confirmationPage} id="cancel-order" />
        </Div>
    </Columns>
);

CancelOrder.propTypes = {
    confirmationPage: PropTypes.shape({
        label: PropTypes.string,
        to: PropTypes.string,
    }),
    text: wysiwygProp,
};

export default CancelOrder;
